import { gql } from '@/modes/waterSupplier/gql';
import { ResultOf } from 'gql.tada';

export const GET_JOB_IDS = gql(`
  query GetJobIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    jobs(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
    }
  }
`);

export const GET_JOBS = gql(`
  query GetJobs(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    jobs(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
      id
      #      status
      created

      waterHazardSurvey {
        jobId
        status
        waterService {
          id
          siteNumber
        }
        contact {
          id
          name
          phones {
            id
            value
          }
        }
      }

      outboundAssignment {
        id
        status
        vendorProfile {
          id
          name
        }
      }

      address {
        id
        street1
        street2
        city
        state
        zip
        zipExt
      }
    }
  }
`);

export type JobItem = ResultOf<typeof GET_JOBS>['jobs'][number];
